import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-24-加号1",
  "use": "icon-24-加号1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"icon-24-加号1\">\n<style type=\"text/css\">\n\t#icon-24-加号1 .st0{fill:#556655;}\n</style>\n<g>\n\t<rect x=\"4\" y=\"11\" class=\"st0\" width=\"16\" height=\"2\" />\n</g>\n<g>\n\t<rect x=\"11\" y=\"4\" class=\"st0\" width=\"2\" height=\"16\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol